/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DashboardAiModelCount } from './DashboardAiModelCount';
import {
  DashboardAiModelCountFromJSON,
  DashboardAiModelCountFromJSONTyped,
  DashboardAiModelCountToJSON,
} from './DashboardAiModelCount';
import type { DashboardUseCaseCounts } from './DashboardUseCaseCounts';
import {
  DashboardUseCaseCountsFromJSON,
  DashboardUseCaseCountsFromJSONTyped,
  DashboardUseCaseCountsToJSON,
} from './DashboardUseCaseCounts';
import type { DashboardUseCaseModelCount } from './DashboardUseCaseModelCount';
import {
  DashboardUseCaseModelCountFromJSON,
  DashboardUseCaseModelCountFromJSONTyped,
  DashboardUseCaseModelCountToJSON,
} from './DashboardUseCaseModelCount';

/**
 *
 * @export
 * @interface DashboardUseCaseModelCounts
 */
export interface DashboardUseCaseModelCounts {
  /**
   *
   * @type {Array<DashboardUseCaseModelCount>}
   * @memberof DashboardUseCaseModelCounts
   */
  results: Array<DashboardUseCaseModelCount>;
  /**
   *
   * @type {DashboardUseCaseCounts}
   * @memberof DashboardUseCaseModelCounts
   */
  useCaseChart: DashboardUseCaseCounts;
  /**
   *
   * @type {DashboardAiModelCount}
   * @memberof DashboardUseCaseModelCounts
   */
  aiModelChart: DashboardAiModelCount;
}

/**
 * Check if a given object implements the DashboardUseCaseModelCounts interface.
 */
export function instanceOfDashboardUseCaseModelCounts(value: object): value is DashboardUseCaseModelCounts {
  if (!('results' in value) || value['results'] === undefined) return false;
  if (!('useCaseChart' in value) || value['useCaseChart'] === undefined) return false;
  if (!('aiModelChart' in value) || value['aiModelChart'] === undefined) return false;
  return true;
}

export function DashboardUseCaseModelCountsFromJSON(json: any): DashboardUseCaseModelCounts {
  return DashboardUseCaseModelCountsFromJSONTyped(json, false);
}

export function DashboardUseCaseModelCountsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): DashboardUseCaseModelCounts {
  if (json == null) {
    return json;
  }
  return {
    results: (json['results'] as Array<any>).map(DashboardUseCaseModelCountFromJSON),
    useCaseChart: DashboardUseCaseCountsFromJSON(json['use_case_chart']),
    aiModelChart: DashboardAiModelCountFromJSON(json['ai_model_chart']),
  };
}

export function DashboardUseCaseModelCountsToJSON(value?: DashboardUseCaseModelCounts | null): any {
  if (value == null) {
    return value;
  }
  return {
    results: (value['results'] as Array<any>).map(DashboardUseCaseModelCountToJSON),
    use_case_chart: DashboardUseCaseCountsToJSON(value['useCaseChart']),
    ai_model_chart: DashboardAiModelCountToJSON(value['aiModelChart']),
  };
}
